// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Editable from 'components/Editable/Editable'
import Link from 'components/Link/Link'
import { get, loop, jsonEqual } from 'utilities/objects'

class PageLinks extends React.Component {
	renderItem = ( key, item ) => {
		if ( ! item.post ) {
			return null
		}

		// const hasImage = ( item.image && item.image.url )
		const hasImage = false
		const className = hasImage ? '-item with-image' : '-item'

		return (
			<Link to={ item.post.url } className={ className } key={ key }>
				<div className="-inner">
					<div className="-text">
						<h3>{ item.post.title }</h3>
					</div>

					{ hasImage &&
						<div className="-image">
							<img
								src={ item.image.url }
								srcSet={ item.image.srcset }
								sizes={ `(max-width: ${siteData.mobile_max_width}) 50vw, 400px` }
								alt={ item.image.alt }
							/>
						</div>
					}
				</div>
			</Link>
		)
	}

	render() {
		const { contentId, sectionId, data, isProtected, userCanEditPage } = this.props
		const markup = loop( data.items, this.renderItem )

		return (
			<div className="section-page-links">
				<div className="-inner">
					<div className="-content">
						{ markup &&
							<Editable
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="items"
								element="div"
								className="-items"
								contentData={ data.items }
							>
								{ markup }
							</Editable>
						|| userCanEditPage &&
							<div className="on-editor-open edit-set-custom-block">
								<Editable
									id={ contentId }
									sectionId={ sectionId }
									sectionType={ data.type }
									sectionDataId="items"
									element="div"
									className="-items"
								/>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		userCanEditPage: siteData.current_user_can_edit_pages
	}
}

export default connect( mapStateToProps )( PageLinks )



// WEBPACK FOOTER //
// ./components/PageSections/PageLinks.jsx